import { lazy } from "react";

export const PsychicDetailsAsync = lazy(() => import("./PsychicDetails"));
